import { iframe_children, bs_iframe_children, app_iframe_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxIframe = {
  name: "cxSwiper3D",
  desc: "3D轮播",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "3D轮播",
        children: app_iframe_children,
        group: "highLevel",
        sort: 62
      }
    ],
    bigScreen: [
      {
        name: "3D轮播",
        children: bs_iframe_children,
        group: "highLevel",
        sort: 62
      }
    ],
    portal: [
      {
        name: "3D轮播",
        children: iframe_children,
        group: "highLevel",
        sort: 62
      }
    ]
  },
  toolbars: [
    {
      name: "cxSwiper3D",
      label: "3D轮播",
      comp: {
        swiper3DComponentConfig: () => import("./toolbars/swiper-options-config.vue"),
        swiper3DComponentData: () => import("./toolbars/swiper-options-data.vue"),
        swiper3DComponentSetting: () => import("./toolbars/swiper-options-setting.vue"),
        swiper3DComponentStyle: () => import("./toolbars/swiper-options-style.vue")
      }
    }
  ]
}

export default cxIframe
